/** 서버 알람/FCM data.alarmGubun·gubun — 교육일지(TraCustom02) */
export const GUBUN_TRA_CUSTOM_02_APPROVAL = 'TRAINING,APPROVAL,TRA_CUSTOM_02';
export const GUBUN_TRA_CUSTOM_02_REJECT = 'TRAINING,REJECT,TRA_CUSTOM_02';

const PRESET_TRA_CUSTOM_02_APPROVAL = {
  icon: '',
  title: '교육일지 최종 결재 요청',
  message: '중간 결재가 완료되었습니다. 최종 결재를 진행해 주세요.',
  buildRoute: (responseData) =>
    responseData
      ? `/M_PendingApprovals/detail/${responseData}`
      : '/M_PendingApprovals',
};

const PRESET_TRA_CUSTOM_02_REJECT = {
  icon: '',
  title: '교육일지 결재 반려',
  useBody: true,
  message: '결재가 반려되었습니다. 사유를 확인한 뒤 수정·재상신해 주세요.',
  buildRoute: (responseData) =>
    responseData
      ? `/M_PendingApprovals/detail/${responseData}`
      : '/M_PendingApprovals',
};

const NOTI_PRESET = {
  default: {
    icon: 'Alarm',
    title: '알림',
    message: '새로운 알림이 있습니다.',
    buildRoute: () => '/M_AlarmList',
  },

  AL_001_001: {
    icon: '',
    title: '산업안전보건위원회 회의록 ',
    message: '회의록 참석자 사인요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/I${responseData}` : `/M_Meeting`,
  },
  AL_001_002: {
    icon: '',
    title: '산업안전보건위원회 회의록',
    message: '대표자 사인요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/I${responseData}` : `/M_Meeting`,
  },
  AL_001_005: {
    icon: '',
    title: '안전보건협의체 회의록',
    message: '회의록 참석자 사인요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/C${responseData}` : `/M_Meeting`,
  },
  AL_001_006: {
    icon: '',
    title: '안전보건협의체 회의록',
    message: '대표자 사인요청입니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Meeting/detail/C${responseData}` : `/M_Meeting`,
  },
  AL_002_001: {
    icon: '',
    title: '작업허가서 ',
    message: '작업허가서가 등록되었습니다. 확인해주세요.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },

  AL_002_002: {
    icon: '',
    title: '작업허가서 반려',
    message:
      '작업허가서가 반려되었습니다. 반려 사유를 확인 후 다시 등록해주세요.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },
  AL_002_003: {
    icon: '',
    title: '작업허가서',
    message: '작업허가서가 최종 승인되었습니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },
  AL_002_004: {
    icon: '',
    title: '작업허가서 연장 신청',
    message: '작업 종료시간 연장 승인 요청이 있습니다.',
    buildRoute: (responseData) =>
      responseData ? `/M_Permit/detail/${responseData}` : `/Permit/list`,
  },

  [GUBUN_TRA_CUSTOM_02_APPROVAL]: PRESET_TRA_CUSTOM_02_APPROVAL,
  [GUBUN_TRA_CUSTOM_02_REJECT]: PRESET_TRA_CUSTOM_02_REJECT,

  AL_006_001: {
    icon: '',
    title: '작업중지',
    useBody: true,
    message: '작업이 중지되었습니다.',
    buildRoute: (responseData, userInfo) => {
      const isAdmin =
        userInfo?.authCd === 'HEAD_MANAGER' ||
        userInfo?.authCd === 'BUSINESS_OWNER';

      if (isAdmin) {
        return responseData
          ? `/M_WorkStop/detail/${responseData}`
          : `/M_WorkStop/list`;
      }
      return `/M_WorkStop/${responseData}`;
    },
  },
  AL_006_002: {
    icon: '',
    title: '작업재개',
    useBody: true,
    message: '작업이 재개되었습니다.',
    buildRoute: (responseData, userInfo) => {
      const isAdmin =
        userInfo?.authCd === 'HEAD_MANAGER' ||
        userInfo?.authCd === 'BUSINESS_OWNER';

      if (isAdmin) {
        return responseData
          ? `/M_WorkStop/detail/${responseData}`
          : `/M_WorkStop/list`;
      }
      return `/Home`;
    },
  },

  AL_007: {
    icon: '',
    title: '작업종료',
    useBody: true,
    message: '작업이 종료되었습니다.',
    buildRoute: () => '/M_WorkEnd',
  },

  AL_008: {
    icon: '',
    title: '보호구 지급',
    message: '보호구가 지급되었습니다. 확인해주세요.',
    buildRoute: () => '/M_EquipIssuanceStatus',
  },

  AL_009_001: {
    icon: '',
    title: '안전신문고(위험요인 제보)',
    message: '위험요인 제보가 접수되었습니다. 확인해주세요.',
    buildRoute: () => '/M_WorkInfo',
  },

  AL_009_002: {
    icon: '',
    title: '안전신문고(아차사고 상황)',
    message: '아차사고 상황 제보가 접수되었습니다. 확인해주세요.',
    buildRoute: () => '/M_WorkInfo',
  },

  AL_009_003: {
    icon: '',
    title: '안전신문고(조치 완료)',
    message: '조치가 완료되었습니다. 확인해주세요.',
    buildRoute: () => '/M_WorkInfo',
  },
};

export const NormalizeAlarmGubunParts = (gubun) =>
  String(gubun || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

/** 알람 목록·푸시: 교육일지(TraCustom02) 승인/반려 구분 문자열 */
export const IsTraCustom02EduLogAlarmGubun = (alarmGubun) => {
  const parts = NormalizeAlarmGubunParts(alarmGubun);
  return (
    parts.includes('TRA_CUSTOM_02') &&
    parts.includes('TRAINING') &&
    (parts.includes('APPROVAL') || parts.includes('REJECT'))
  );
};

/** 정확히 일치하거나 TRAINING+APPROVAL|REJECT+TRA_CUSTOM_02 조합으로 프리셋 조회 */
export const GetNotiPreset = (gubun) => {
  if (gubun != null && gubun !== '') {
    const direct = NOTI_PRESET[gubun];
    if (direct) return direct;
  }
  const parts = NormalizeAlarmGubunParts(gubun);
  if (parts.includes('TRA_CUSTOM_02') && parts.includes('TRAINING')) {
    if (parts.includes('REJECT')) {
      return NOTI_PRESET[GUBUN_TRA_CUSTOM_02_REJECT] || NOTI_PRESET.default;
    }
    if (parts.includes('APPROVAL')) {
      return (
        NOTI_PRESET[GUBUN_TRA_CUSTOM_02_APPROVAL] || NOTI_PRESET.default
      );
    }
  }
  return NOTI_PRESET.default;
};

export default NOTI_PRESET;
